import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Simple fetch hook for public content endpoints
export function usePublic(path) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    api
      .get(path)
      .then(({ data }) => active && setData(data))
      .catch(() => active && setData(null))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [path]);

  return { data, loading };
}
